<template>
<div>
  <wt-re-request-tip :re-load="load" v-show="loadFailed"></wt-re-request-tip>
  <pt-lab-test-platform-form v-loading="loading" ref="form" class="pt-lab-test-platform-form__withData" v-model="formObj" :isEdit="isEdit"></pt-lab-test-platform-form>
</div>

</template>

<script>
import PtLabTestPlatformForm from './index'
export default {
  name: 'pt-lab-test-platform-form__withData',
  components: {
    'pt-lab-test-platform-form': PtLabTestPlatformForm
  },
  computed: {
    form () {
      return this.$refs.form
    }
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      formObj: {},
      loading: false,
      loadFailed: false
    }
  },
  methods: {
    // formValidate () {
    //   return this.form.validate()
    // }
    submit () {
      this.form.validate().then(async formValue => {
        console.log(this.formObj)
        this.$emit('upateLoading', true)
        try {
          let methodId = await this.$store.dispatch('methodAdd', { name: this.formObj.name })
          let primary = await this.$store.dispatch('getPrimaryOrganization')
          let data = {
            clientOrganizationId: primary.id,
            organizationRole: 'LAB',
            dayType: this.formObj.dayType,
            name: this.formObj.name,
            methodId: methodId.data
          }
          if (this.formObj.cycle) {
            data.testCycle = 'P0Y0M' + this.formObj.cycle + 'D'
          }
          this.$store.dispatch('labTestPlatformAdd', data).then(data => {
            this.$emit('upateLoading', false)
            this.$message.success('新建成功!')
            this.$router.push({ name: 'lab-test-platform-list' })
          }).catch(errorMessage => {
            this.$emit('upateLoading', false)
            console.error(errorMessage)
            this.$message.error(errorMessage)
          })
        } catch (err) {
          this.$emit('upateLoading', false)
          console.error(err)
          this.$message.error(err)
        }
      })
    },
    edit () {
      this.form.validate().then(async formValue => {
        this.$emit('upateLoading', true)
        if (this.formObj.cycle) {
          this.formObj.testCycle = 'P0Y0M' + this.formObj.cycle + 'D'
        }
        // let res = await this.$store.dispatch('methodUpdate', { name: this.formObj.name, methodId: this.formObj.methodId })
        this.$store.dispatch('methodUpdate', { name: this.formObj.name, id: this.formObj.methodId }).then(data => {
          this.formObj.testCycle = 'P0Y0M' + this.formObj.cycle + 'D'
          this.$store.dispatch('updateLabProduct', this.formObj).then(data => {
            this.$emit('upateLoading', false)
            this.$message.success('编辑成功!')
            this.$router.push({ name: 'lab-test-platform-list' })
          }).catch(errorMessage => {
            this.$emit('upateLoading', false)
            console.error(errorMessage)
            this.$message.error(errorMessage)
          })
        }).catch(errorMessage => {
          this.$emit('upateLoading', false)
          console.error(errorMessage)
          this.$message.error(errorMessage)
        })
      })
    },
    load () {
      this.$emit('upateLoading', true)
      this.$store.dispatch('getLabTestPlatform', this.$route.params.id).then(data => {
        if (data.testCycle) {
          data.cycle = data.testCycle.replace(/[^0-9]/ig, '')
        }
        this.formObj = data
        this.$emit('upateLoading', false)
        this.loadFailed = false
      }).catch(errorMessage => {
        this.$emit('upateLoading', false)
        this.loadFailed = true
        console.error(errorMessage)
        this.$message.error(errorMessage)
      })
    }
  },
  created () {
    if (this.isEdit) {
      this.load()
    }
  }
}
</script>
